//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('currencyExRates', {
//        templateUrl: 'views/components/views/currencyExRates/currencyExRates.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'currencyExRatesService', function ($stateParams, currencyExRatesService) {
//            const vm = this;
//            let valutaId = $stateParams.valuta_id;
//            let currencyTypeKeyno = $stateParams.currencytype_keyno;

//            vm.model = {
//                setting: {},
//    			itemsListCurrencyExRates: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await currencyExRatesService.getSetting({
//                    valuta_id: valutaId,
//                    currencytype_keyno: currencyTypeKeyno
//                }))[0];

//                return loadCurrencyExRates();
//            }
    		
//            async function loadCurrencyExRates() {
//                return vm.model.itemsListCurrencyExRates = await currencyExRatesService.listCurrencyExRates(vm.model.setting);
//            }

//            vm.$onInit = function () {
//                loadSetting();
//            }
//        }]
//    });
//})();
